import { PropsWithChildren } from 'react';
import { Spin } from '@timeedit/ui-components/antd';
import './index.scss';

// TYPES
type Props = PropsWithChildren<{
  isLoading: boolean;
}>;

const LoadingWrapper = ({ children, isLoading }: Props) => {
  return (
    <div className="loading-wrapper">
      <div className="content">{children}</div>
      {isLoading && (
        <div className="spinner">
          <Spin size="large" />
        </div>
      )}
    </div>
  );
};

export default LoadingWrapper;
